import { showError, showFile } from '../App';
import $ from 'jquery';
import { Table } from 'antd';

const bytesToHuman = (bytes) => {
    if (!bytes) return '0 B';
    const map = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];  // 映射
                                                                        // 可能会超出, 出现 undefined
                                                                        // 一般情况下, 是不会出现的
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + map[i];
}

const GetById = (id) => {
    var d = {};
    $.ajax({
        url: 'https://files-index.tes286.site/index.json',
        type: 'GET',
        dataType: 'json',
        async: false,
        success: (data) => {
            d = data;
        },
        error: (err) => {
            showError('获取文件列表失败 (ErrGetFiles)\n' + err);
        }
    });
    if (d === {}) {
        return false;
    }
    const index = d.index
    const path = id.split('/')

    /**
     * Index format:
     * [
     *  {
     *     "name": "File",  // file name
     *     "type": "file",  // file type
     *     "size": "100",   // file size (pre Byte)
     *     "url": "https://files.tes286.site/File"  // file url
     *  },
     *  {
     *    "name": "Folder", // folder name
     *    "type": "folder", // folder type
     *    "children": [     // children
     *     {
     *      "name": "File",
     *      "type": "file",
     *      "size": "100",
     *      "url": "https://files.tes286.site/Folder/File"
     *     }
     *    ]
     *  }
     * ]
     */

    var file = index;
    if (id !== '/') {
        // 循环找路径
        for (var i = 0; i < path.length; i++) {
            // 循环找文件
            for (var j = 0; j < file.length; j++) {
                // 如果找到文件
                if (file[j].name === path[i]) {
                    if (file[j].type === 'folder') {
                        file = file[j].children;
                    } else {
                        file = file[j];
                    }
                    // 找下一级
                    break;
                }
            }
        }
    } else {
        file = {
            "name": "root",
            "type": "folder",
            "children": index,
            "size": d.total_size
        }
    }
    if (file === index) {
        showError('文件不存在 (ErrFileNotFound)\n' + id);
        return false;
    }
    showFile(
        <Table dataSource={[file]} columns={[
            {
                title: '文件名',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => {
                    if (record.url){
                        return <a href={record.url} target='_blank' rel="noreferrer">{text}</a>
                    } else {
                        return text
                    }
                },
                width: '30%'
            },
            {
                title: '文件类型',
                dataIndex: 'type',
                key: 'type',
                width: '5%',
                render: (text) => {
                    if (text === 'dir') {
                        return <span>文件夹</span>
                    } else if (text === 'file') {
                        return <span>文件</span>
                    }
                }
            },
            {
                title: '文件大小',
                dataIndex: 'size',
                key: 'size',
                render: text => bytesToHuman(text),
                width: '10%',
            },
            {
                title: '文件地址',
                dataIndex: 'url',
                key: 'url',
                render: (text, record) => {
                    if (record.type === 'file') {
                        // Make sure it will open in new tab
                        return <a href={record.url} target="_blank" rel="noreferrer">{text}</a>
                    }
                },
                width: '35%',
            },
        ]} style={{width: '100vh'}} />
    )

};

export { GetById };